const SiteSearchAPIConnector = require("@elastic/search-ui-site-search-connector").default;

const connector = new SiteSearchAPIConnector({
                        engineKey: "q_mXsgTid_9iQ4xZz8iy",
                        documentType: "page"
                      });

const getSearchProviderConfig = onSearch => {

  return {
    apiConnector: connector,
    autocompleteQuery: {
      results: {
        result_fields: {
          title: {snippet: {size: 100, fallback: true}},
          body: {snippet: {size: 100, fallback: true}},
          url: {raw: {}}
        },
        size: 10
      },
    },
    searchQuery: {
      result_fields: {
        title: {snippet: {size: 100, fallback: true}},
        body: {snippet: {size: 300, fallback: true}},
        url: {raw: {}},
      },
    },
    alwaysSearchOnInitialLoad: false,
    trackUrlState: false,
    onSearch: (state, queryConfig, next) => {
      if(state.searchTerm) {
        onSearch();
      }
      return next(state, queryConfig);
    }
  }
};

export { getSearchProviderConfig };